import React from 'react';
import { registerComponent, registerSkinnableComponent } from '../registry';
import { COMPONENT_TYPES } from '../../../constants';
import ImageTextEditor from './ImageText.editor';
import ImageTextProperties from './ImageText.properties';
import { ImageTextSkinnable } from './ImageTextSkinnable';
import ComponentSkinWrapper from '../../skins/ComponentSkinWrapper';
import { ImageTextProps } from './ImageText.types';

// 스킨 가능한 컴포넌트로 등록
registerSkinnableComponent(ImageTextSkinnable);

// 외부 스킨 지원을 위한 래퍼 컴포넌트
const ImageTextWrapper: React.FC<ImageTextProps> = (props) => {
  const selectedSkin = props.componentProps?.skin || 'basic';
  
  // ComponentData 구성
  const componentData = {
    id: props.id || `${COMPONENT_TYPES.IMAGE_TEXT}-${Date.now()}`,
    type: COMPONENT_TYPES.IMAGE_TEXT,
    props: props,
    componentProps: props.componentProps || {},
    content: props.content,
    style: props.style,
    viewMode: props.viewMode || 'pc',
    externalSkin: props.externalSkin
  };
  
  // 렌더 모드 결정
  const mode = props.isPreview ? 'preview' : 'production';
  
  // 에디터 props (필요한 경우)
  const editorProps = (props as any).isEditor ? {
    isSelected: (props as any).isSelected || false,
    onSelect: (props as any).onSelect || (() => {}),
    onEdit: (props as any).onEdit || (() => {}),
    onDelete: (props as any).onDelete || (() => {})
  } : undefined;
  
  return (
    <ComponentSkinWrapper 
      component={ImageTextSkinnable}
      componentData={componentData}
      skinId={selectedSkin}
      mode={mode}
      editorProps={editorProps}
    />
  );
};

// 레거시 호환성을 위한 기존 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.IMAGE_TEXT,
  component: ImageTextWrapper,
  editorComponent: ImageTextEditor,
  properties: ImageTextProperties,
  name: '이미지-텍스트',
  category: 'content',
  icon: '🖼️',
  defaultProps: {
    content: '<h3>제목을 입력하세요</h3><p>여기에 내용을 입력하세요. <strong>굵게</strong> 또는 <em>기울임꼴</em>로 강조할 수 있습니다.</p>',
    componentProps: {
      imageUrl: 'https://via.placeholder.com/400x300',
      imagePosition: 'left',
      imageWidth: '50%',
      textWidth: '50%',
      gap: '20px',
      verticalAlign: 'middle',
      useSecondImage: false,
      skin: 'basic'
    },
    style: {
      width: '100%',
      padding: '20px',
      boxSizing: 'border-box',
    }
  },
  skinnable: ImageTextSkinnable
});

// 컴포넌트 및 타입 내보내기
export { ImageTextWrapper as ImageTextComponent };
export { default as ImageTextEditor } from './ImageText.editor';
export { default as ImageTextProperties } from './ImageText.properties';
export * from './ImageText.types';
export { ImageTextSkinnable }; 